module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-nav-list"
  }, [_c('div', {
    staticClass: "mobile-nav-list--main-menu"
  }, [_c('div', {
    staticClass: "grid--container grid--container__no-edge"
  }, [_c('ul', {
    staticClass: "u-reset mobile-nav-list--items"
  }, _vm._l((_vm.menu), function(navItem, navItemIdx) {
    return _c('li', {
      staticClass: "mobile-nav-list--item"
    }, [_c('div', {
      staticClass: "mobile-nav-list--item-root"
    }, [_c('router-link', {
      staticClass: "u-reset mobile-nav-list--link",
      attrs: {
        "to": navItem.path
      }
    }, [_c('span', {
      staticClass: "mobile-nav-list--title",
      domProps: {
        "textContent": _vm._s(navItem.label)
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "mobile-nav-list--dropdown-btn",
      class: _vm.dropdownBtnClasses(navItemIdx),
      on: {
        "click": function($event) {
          _vm.updateState(navItemIdx)
        }
      }
    }, [_c('cmp-icon', {
      staticClass: "mobile-nav-list--dropdown-icon",
      attrs: {
        "symbol": "navigation_mobile_down",
        "size": "x-small"
      }
    })], 1)], 1), _vm._v(" "), _c('cmp-accordion', {
      attrs: {
        "is-active": _vm.accordionStates[navItemIdx],
        "passive-mode": true
      },
      scopedSlots: _vm._u([{
        key: "body",
        fn: function(props) {
          return [_c('div', {
            staticClass: "mobile-nav-list--accordion-body"
          }, [_c('ul', {
            staticClass: "u-reset mobile-nav-list--sub-items"
          }, _vm._l((navItem.children), function(subNavItem, subNavItemIdx) {
            return _c('li', {
              staticClass: "mobile-nav-list--sub-item"
            }, [_c('router-link', {
              staticClass: "u-reset mobile-nav-list--sub-link",
              attrs: {
                "to": subNavItem.path
              },
              domProps: {
                "innerHTML": _vm._s(subNavItem.label)
              }
            })], 1)
          }))])]
        }
      }])
    })], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav-list--meta-menu"
  }, [_c('cmp-meta-nav', {
    attrs: {
      "facet": "mobile",
      "container": _vm.meta
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ff7260d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff7260d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/mobile-nav-list/index.vue
// module id = 596
// module chunks = 7